<template>
    <b-card-group>
        <b-card class="report-card">
            <ReportSchedule :data="data" />

            <ReportBilling :data="data" :dialogs="dialogs" />

            <ReportClient :data="data" />

            <ReportInventory :data="data" :dialogs="dialogs" />

            <ReportStaff :data="data" />

            <ReportCommunication ref="reportCommunication" :data="data" />

            <ReportPatient :data="data" />

            <CustomReport
                v-if="this.$route.name == 'custom_report'"
                :data="data"
            />

            <SampleReport v-if="this.$route.params.id == 999" :data="data" />
        </b-card>
    </b-card-group>
</template>
<script>
import CREPORT from "@/constants/report.js";
import ReportHelper from "./helper";
import SampleReport from "./sample";
import ReportSchedule from "@/module/report/details/report-schedule";
import ReportClient from "@/module/report/details/report-client";
import ReportInventory from "@/module/report/details/report-inventory";
import ReportBilling from "@/module/report/details/report-billing";
import ReportStaff from "@/module/report/details/report-staff";
import ReportCommunication from "@/module/report/details/report-communication";
import ReportPatient from "@/module/report/details/report-patient";
import CustomReport from "@/module/report/module/custom/custom-report";
export default {
    components: {
        ReportSchedule,
        ReportBilling,
        ReportClient,
        ReportInventory,
        ReportStaff,
        ReportCommunication,
        ReportPatient,
        SampleReport,
        CustomReport
    },
    mixins: [ReportHelper],
    props: {
        data: {
            default() {},
            type: Object
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        this.storeAudit(this.$route.params.id);
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // -- reset datePickerRange selected option;
            vm.data.datePickerRange = false;
            vm.data.ignoreFormat = false;
        });
    },
    data() {
        return { CREPORT: CREPORT };
    },
    methods: {
        async storeAudit(reportId) {
            const fullPath = _.clone(this.$router.currentRoute.fullPath);

            if (!reportId) {
                return;
            }

            await this._getSetting();
            await this._saveAudit({
                action: "view",
                path: "/report/report/view." + reportId,
                reference_id: reportId,
                fullPath
            });
        },
        resetCheckBoxes() {
            this.$refs.reportCommunication.resetCheckBoxes();
        }
    }
};
</script>
<style scoped>
#app .report-card {
    background: #f2f2f2;
}
</style>
